import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTripDotComComponent } from './simple-icons-trip-dot-com.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTripDotComComponent ],
    exports:      [ SimpleIconsTripDotComComponent ],
    bootstrap:    []
})
export class SimpleIconsTripDotComModule {}
